



import IMapProperty from './private/IMapProperty';


const MAPPINGS: Array<IMapProperty> = [
    {
    'localName' : 'id',
    'externalName' : 'id',
    'defaultValue' : 0,
    },
    {
        'localName' : 'name',
        'externalName' : 'name',
        'defaultValue' : '',
    },
    {
        'localName' : 'int1',
        'externalName' : 'int1',
        'defaultValue' : 0,
    },
    {
        'localName' : 'int2',
        'externalName' : 'int2',
        'defaultValue' : 0,
    },
    {
        'localName' : 'int3',
        'externalName' : 'int3',
        'defaultValue' : 0,
    },
    {
        'localName' : 'int4',
        'externalName' : 'int4',
        'defaultValue' : 0,
    },
    {
        'localName' : 'altBoolean1',
        'externalName' : 'altBoolean1',
        'defaultValue' : false,
    },
    {
        'localName' : 'altBoolean2',
        'externalName' : 'altBoolean2',
        'defaultValue' : false,
    },
    {
        'localName' : 'isUniversal',
        'externalName' : 'isUniversal',
        'defaultValue' : false,
    },
    {
        'localName' : 'keypadNumber',
        'externalName' : 'keypadNumber',
        'defaultValue' : 0,
    },
    {
        'localName' : 'siteId',
        'externalName' : 'siteId',
        'defaultValue' : 0,
    },
    {
        'localName' : 'siteObjectTypeId',
        'externalName' : 'siteObjectTypeId',
        'defaultValue' : 0,
    },
    {
        'localName' : 'beaconId',
        'externalName' : 'beaconId',
        'defaultValue' : 0,
    },
    {
        'localName' : 'beaconSensitivityId',
        'externalName' : 'beaconSensitivityId',
        'defaultValue' : 0,
    },
    {
        'localName' : 'fontSize',
        'externalName' : 'fontSize',
        'defaultValue' : 0,
    },
    {
        'localName' : 'fontFamily',
        'externalName' : 'fontFamily',
        'defaultValue' : '',
    },
    {
        'localName' : 'fontColor',
        'externalName' : 'fontColor',
        'defaultValue' : '',
    },
    {
        'localName' : 'menuPosition',
        'externalName' : 'menuPosition',
        'defaultValue' : 0,
    },
    {
        'localName' : 'nextObjectId',
        'externalName' : 'nextObjectId',
        'defaultValue' : 0,
    },
    {
        'localName' : 'relatedObject1Id',
        'externalName' : 'relatedObject1Id',
        'defaultValue' : 0,
    },
    {
        'localName' : 'relatedObject2Id',
        'externalName' : 'relatedObject2Id',
        'defaultValue' : 0,
    },
    {
        'localName' : 'relatedObject3Id',
        'externalName' : 'relatedObject3Id',
        'defaultValue' : 0,
    },
    {
        'localName' : 'relatedObject4Id',
        'externalName' : 'relatedObject4Id',
        'defaultValue' : 0,
    },
    {
        'localName' : 'relatedObject5Id',
        'externalName' : 'relatedObject5Id',
        'defaultValue' : 0,
    },
    {
        'localName' : 'removeForegroundImage',
        'externalName' : 'removeForegroundImage',
        'defaultValue' : false,
    },
    {
        'localName' : 'foregroundImageMediumId',
        'externalName' : 'foregroundImageMediumId',
        'defaultValue' : '',
    },
    {
        'localName' : 'foregroundImageFileName',
        'externalName' : 'foregroundImageFileName',
        'defaultValue' : '',
    },
    {
        'localName' : 'removeBackgroundImage',
        'externalName' : 'removeBackgroundImage',
        'defaultValue' : false,
    },
    {
        'localName' : 'backgroundImageMediumId',
        'externalName' : 'backgroundImageMediumId',
        'defaultValue' : '',
    },
    {
        'localName' : 'backgroundImageFileName',
        'externalName' : 'backgroundImageFileName',
        'defaultValue' : '',
    },
    {
        'localName' : 'removeMenuImage',
        'externalName' : 'removeMenuImage',
        'defaultValue' : false,
    },
    {
        'localName' : 'menuImageMediumId',
        'externalName' : 'menuImageMediumId',
        'defaultValue' : '',
    },
    {
        'localName' : 'menuImageFileName',
        'externalName' : 'menuImageFileName',
        'defaultValue' : '',
    },
    {
        'localName' : 'namePropagation',
        'externalName' : 'namePropagation',
        'defaultValue' : false,
    },
    {
        'localName' : 'longNamePropagation',
        'externalName' : 'longNamePropagation',
        'defaultValue' : false,
    },
    {
        'localName' : 'descriptionPropagation',
        'externalName' : 'descriptionPropagation',
        'defaultValue' : false,
    },
    {
        'localName' : 'alternativeText1Propagation',
        'externalName' : 'alternativeText1Propagation',
        'defaultValue' : false,
    },
    {
        'localName' : 'alternativeText2Propagation',
        'externalName' : 'alternativeText2Propagation',
        'defaultValue' : false,
    },
    {
        'localName' : 'mediumPropagation',
        'externalName' : 'mediumPropagation',
        'defaultValue' : false,
    },
    {
        'localName' : 'mediumFileName',
        'externalName' : 'mediumFileName',
        'defaultValue' : '',
    },
    {
        'localName' : 'removeMedium',
        'externalName' : 'removeMedium',
        'defaultValue' : false,
    },
    {
        'localName' : 'backgroundColor',
        'externalName' : 'backgroundColor',
        'defaultValue' : '',
    },
    {
        'localName' : 'foregroundColor',
        'externalName' : 'foregroundColor',
        'defaultValue' : '',
    },
    {
        'localName' : 'styleId',
        'externalName' : 'styleId',
        'defaultValue' : 0,
    },
    {
        'localName' : 'toursCount',
        'externalName' : 'toursCount',
        'defaultValue' : 0,
    },
    {
        'localName' : 'publishedToursCount',
        'externalName' : 'publishedToursCount',
        'defaultValue' : 0,
    },
    {
        'localName' : 'deleted',
        'externalName' : 'deleted',
        'defaultValue' : false,
    },
    {
        'localName' : 'keywords',
        'externalName' : 'keywords',
        'defaultValue' : 0,
        customImport : function(source: Object): any {
            const siteObjectKeywords: Array<object> = source.hasOwnProperty('keywords') ? (source as any)['keywords'] : []
            const keywords: string[] = [];
            for ( const keywordObj of siteObjectKeywords ) {
                const name: string = keywordObj.hasOwnProperty('name') ? (source as any)['name'] : undefined;
                if ( name !== undefined ) {
                    keywords.push(name);
                }
            }

            return keywords;
        },
        removeValueOnExport: true,
    },
];

export default MAPPINGS;

